import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2.tsx';
import { deleteCustomDetail } from '@dealstack/frontend/shared/dataExchange/services/mip.service.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';

type DeleteCustomDetailParams = {
	customDetailId: string;
};

export const useDeleteCustomDetail = (successMessage?: string) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({ customDetailId }: DeleteCustomDetailParams) => {
			if (!customDetailId) {
				throw new Error('Custom detail ID not found');
			}
			return deleteCustomDetail({ customDetailId });
		},
		onSuccess: () => {
			showToastV2({
				title: successMessage,
			});
			return queryClient.invalidateQueries({ queryKey: [API_PATHS.MIP_CUSTOM_DETAIL_GET] });
		},
	});
};
